import { UserBase, WebUser } from 'types/User';
import { isSelfLink } from './link';

export const getUserFullName = (user?: UserBase): string | undefined =>
  user ? `${user.firstName} ${user.lastName}` : undefined;

export const getUserInitials = (user: UserBase): string => (user.firstName.charAt(0) + user.lastName.charAt(0)).toUpperCase();

export const webUserHasSelfLink = (webUser: WebUser): boolean =>
  !!webUser.links.find((link) => isSelfLink(link));
